import { useQueryClient } from '@tanstack/react-query';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';
import { BrandProfilePayload } from 'domains/brand/types';
import MutationKeys from './keys';
import QueryKeys from 'hooks/queries/keys';

const useUpdateBrandProfile = () => {
    const queryClient = useQueryClient();

    return useMutation<BrandProfilePayload>(
        MutationKeys.UPDATE_BRAND_PROFILE,
        CuredApiPaths.BRAND_PROFILE,
        {
            onSuccess: () => {
                queryClient.invalidateQueries(QueryKeys.BRAND_PROFILE);
            },
        },
        ApiMethods.PUT
    );
};

export default useUpdateBrandProfile;
